import { render, staticRenderFns } from "./PolicyForm.vue?vue&type=template&id=3be8301b"
import script from "./PolicyForm.vue?vue&type=script&lang=js"
export * from "./PolicyForm.vue?vue&type=script&lang=js"
import style0 from "./PolicyForm.vue?vue&type=style&index=0&id=3be8301b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports